import React from 'react';
import '../css files/Skills.css'; // Create a CSS file for styling

const Skills = () => {
  return (
    <div className="SkillsContainer">
      <h1>Technologies Used</h1>
      <table>
        <thead>
          <tr>
            <th>Technology</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>React</td>
            <td>
              I have extensive experience with React and have used it to build
              interactive and responsive user interfaces for web applications
            </td>
          </tr>
          <tr>
            <td>Node.js</td>
            <td>
              I've utilized Node.js to develop server-side applications and RESTful
              APIs, making it possible to handle data and server operations
              efficiently
            </td>
          </tr>
          <tr>
    <td>Docker</td>
    <td>
      I am proficient in Docker, leveraging it to containerize applications for seamless deployment. I have hands-on experience in creating Docker images, composing multi-container applications, and orchestrating containers for efficient development and deployment workflows.
    </td>
  </tr>
          <tr>
            <td>JavaScript</td>
            <td>
              JavaScript is the primary language I use for both front-end and
              back-end development. I leverage its power to create dynamic and
              interactive web applications
            </td>
          </tr>
          <tr>
            <td>C/C++</td>
            <td>
            I completed a C programming course during my second year of university, where I extended my knowledge to include coding in C++. I utilized C++ in two university projects: the Arduino Sumo Robot project and a real-life network simulation. You can find both projects on my personal GitHub repository
            </td>
          </tr>
          <tr>
            <td>MongoDB</td>
            <td>
            I gained proficiency in MongoDB while working on various projects, using it as the primary NoSQL database solution. I've employed MongoDB for tasks such as data storage, retrieval, and analysis. You can explore my MongoDB-related work in my GitHub portfolio
            </td>
          </tr>
          <tr>
            <td>Python</td>
            <td>
            I primarily utilize Python for honing my problem-solving skills on platforms like LeetCode and CodeWars due to its versatility and simplicity
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Skills;
